export default "/images/5cb56cb85b65f22a5bbeafc5508b9f16.avif";